import React, { useEffect, useState } from "react";

type Consent = {
  analytics: boolean;
  marketing: boolean;
  necessary: true; // immer true; technisch-notwendige ohne Einwilligung
};

const LS_KEY = "cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);
  const [consent, setConsent] = useState<Consent>({
    necessary: true,
    analytics: false,
    marketing: false,
  });

  useEffect(() => {
    const saved = localStorage.getItem(LS_KEY);
    if (!saved) setOpen(true);
  }, []);

  const save = (c: Consent) => {
    localStorage.setItem(LS_KEY, JSON.stringify({ ...c, date: new Date().toISOString() }));
    setOpen(false);
    // Beispiel: Nur wenn analytics erlaubt ist, Skript nachladen
    if (c.analytics) {
      // hier dein Analytics-Snippet dynamisch einfügen
      // z.B. gtag, Plausible, Matomo ...
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 bg-white/95 backdrop-blur border-t">
      <div className="max-w-[1100px] mx-auto px-4 py-4 grid gap-3 sm:grid-cols-[1fr_auto] items-center">
        <div className="text-sm text-slate-700">
          Wir verwenden Cookies/ähnliche Technologien, um unsere Website bereitzustellen (erforderlich) und –
          nach Ihrer Einwilligung – für Statistik (Analytics) und Marketing. Sie können Ihre Einwilligung
          jederzeit in der <a className="underline" href="/cookies">Cookie-Richtlinie</a> widerrufen.
        </div>
        <div className="flex flex-wrap gap-2 justify-end">
          <button
            className="px-3 py-2 rounded-lg border text-sm"
            onClick={() => save({ necessary: true, analytics: false, marketing: false })}
          >
            Nur erforderlich
          </button>
          <button
            className="px-3 py-2 rounded-lg border text-sm"
            onClick={() => setConsent((c) => ({ ...c, analytics: !c.analytics }))}
            aria-pressed={consent.analytics}
          >
            Analytics: {consent.analytics ? "an" : "aus"}
          </button>
          <button
            className="px-3 py-2 rounded-lg border text-sm"
            onClick={() => setConsent((c) => ({ ...c, marketing: !c.marketing }))}
            aria-pressed={consent.marketing}
          >
            Marketing: {consent.marketing ? "an" : "aus"}
          </button>
          <button
            className="px-3 py-2 rounded-lg bg-[#FF6B00] text-white text-sm rounded-lg"
            onClick={() => save(consent)}
          >
            Auswählen & speichern
          </button>
          <button
            className="px-3 py-2 rounded-lg bg-[#FF6B00] text-white text-sm"
            onClick={() => save({ necessary: true, analytics: true, marketing: true })}
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
